<template lang="pug">
  transition
    router-link(:to="'/'+$i18n.locale" :class="classObj").HeaderLogo
      img.HeaderLogo_logo(src="/img/logos/musee-logo.png")
      LogoDiamonds(ref="logo").HeaderLogo_logo
      transition(name="translate")
        .HeaderLogo_name(v-if="isVisible") Musée
      transition(name="translate")
        .HeaderLogo_sign(v-if="isVisible")
</template>

<script>

import { mapGetters } from 'vuex'
import LogoDiamonds from '@/components/LogoDiamonds'

export default {
  components: { LogoDiamonds },
  data () {
    return {
      isVisible: true
    }
  },
  computed: {
    ...mapGetters(['menuOpened']),
    classObj: function () {
      return {
        [`HeaderLogo-dark`]: this.menuOpened,
        [`HeaderLogo-light`]: !this.menuOpened
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  },
  mounted () {
    this.$refs.logo.start(true)
    window.addEventListener('resize', this.onResize)
    this.onResize()
  },
  methods: {
    playLogo () {
      this.$refs.logo.headerLogoPlay()
    },
    onResize () {
      if (window.innerWidth < 768 && this.$router.currentRoute.name != 'home') {
        this.isVisible = false
      } else {
        this.isVisible = true
      }
    }
  }
}

</script>

<style lang="stylus" scoped>

.HeaderLogo
  z-index 15
  position fixed
  top 20px
  pointer-events auto
  left 10px
  height unset
  width unset

  .translate-enter, .translate-leave-to
    opacity: 0
    transform translateX(20%)

  .translate-enter-active, .translate-leave-active
    transition all .6s $ease

  @media $mq_m
    top 30px
    left 20px
    height 140px
    width 230px

  // ---
  // Animation d'apparition
  // ---
  &.v-enter
    opacity: 0
    transform translate3d(0, -20px, 0)

  &.v-enter-active
    transition all .8s $ease
  //--- fin animation

  &_logo

    transform scale( .8 )

    @media $mq_s_only
      width 60px
      height: auto

  img.HeaderLogo_logo

    display none

    @media $mq_s_only

      display block

  .Logo_diamonds

    display block
    top: -45px;
    position relative

    @media $mq_s_only

      display none

  &_name
    font-size: 17px;
    font-weight 800
    letter-spacing: 0.8px;
    position absolute
    left 43px
    transition color 0.6s $ease
    top 42px
    text-transform uppercase
    text-align: left;
    font-family $font-logo

    @media $mq_s_only
      display: none

    @media $mq_m
      font-size: 25px;
      left 65px
      top 55px

    @media $mq_l
      font-size: 34px;

  &_sign

    position absolute
    top 65px
    left 45px
    width 70px
    height 15px
    transition background-image 0.8s $ease
    background-image url(/img/logos/sign-logo.png)
    background-size cover

    @media $mq_m
      width 105px
      height: 23px
      top 100px
      left 80px

    @media $mq_l
      width 140px
      height 30px

    @media $mq_s_only
      display: none

  &-light
    color: white

  &-dark
    color: $black

    .HeaderLogo_sign
      background-image url(/img/logos/sign-logo-black.png)

</style>
